if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/core.production.min.js")
} else {
  module.exports = require("./cjs/core.development.js")
}



//////////////////
// WEBPACK FOOTER
// ./~/@lingui/core/index.js
// module id = 47
// module chunks = 35783957827783 114276838955818 218538773642512